/**
 * 打开南方+客户端
 */
const env =
  process.env.VUE_APP_RUN_ENV === 'pro' ? '' : process.env.VUE_APP_RUN_ENV

const openNfApp = async (reportUuid = '', reporterName = '') => {
  let isInsideVer = await window.T.native.getInsideVersion()
  if (!window.OpenApp) {
    window.console.error('万恶的openApp没有加载成功')
    return
  }
  let params = {
    shareType: 'reporterHomepage',
    id: reportUuid,
    needClipboard: false,
    address: window.location.href,
    openAppBigDataInfo: {
      origin: 7,
      sourceTag: 19,
      clickPosition: 36,
      itemId: reportUuid,
      weMediaId: reportUuid,
      url: window.location.href
    }
  }
  if(reporterName){
    params.title = '前往"' + reporterName + '"作品集主页'
  } else {
    let titleArr = document.title.split('-')
    params.title = '前往"' + titleArr[0] + '"作品集主页'
  }
  !isInsideVer && window.OpenApp(params, env)
}

export default openNfApp
